var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordSuccessTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_507_9219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.853 57.6876C124.432 60.2663 124.432 64.4465 121.853 67.0239L77.5658 111.312C74.987 113.89 70.8082 113.89 68.2295 111.312L47.147 90.2287C44.5683 87.6512 44.5683 83.4711 47.147 80.8936C49.7245 78.3149 53.9046 78.3149 56.482 80.8936L72.897 97.3086L112.517 57.6876C115.095 55.1102 119.276 55.1102 121.853 57.6876ZM169 84.5C169 131.207 131.201 169 84.5 169C37.7927 169 0 131.201 0 84.5C0 37.7927 37.7991 0 84.5 0C131.207 0 169 37.7991 169 84.5ZM155.797 84.5C155.797 45.0905 123.904 13.2031 84.5 13.2031C45.0905 13.2031 13.2031 45.0956 13.2031 84.5C13.2031 123.91 45.0956 155.797 84.5 155.797C123.91 155.797 155.797 123.904 155.797 84.5Z",
    fill: "#4B9642"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_507_9219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 169,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordSuccessTick);
export default __webpack_public_path__ + "static/media/password-success-tick.0441b4a26c40f2202bc8d4000199a16c.svg";
export { ForwardRef as ReactComponent };